module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/标签-作者.654f3.png";